import { render } from "./PreviewModule.vue?vue&type=template&id=05907ca2"
import script from "./PreviewModule.vue?vue&type=script&lang=js"
export * from "./PreviewModule.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\daniel.montano\\Desktop\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__